(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('avananApDebugLinksLogic', ["simpleSortableLogicCore", "fileDao", "widgetPolling", "defaultListConverter", "$q", function (simpleSortableLogicCore, fileDao, widgetPolling, defaultListConverter, $q) {
        return function ($scope, logic) {
            if (_($scope.model.wrapper.showLoading).isUndefined()) {
                $scope.model.wrapper.showLoading = true;
            }
            $scope.model.wrapper.isLoading = true;
            var id = logic.entityId || widgetPolling.scope().id;
            return simpleSortableLogicCore($scope, logic, {
                retrieve: function () {
                    return fileDao.avananApDebugLinks(id, logic.entityType).converter(function (input) {
                        var deferred = $q.defer();
                        var rows = [];
                        var inputRows = [];
                        if ($scope.model.externalData && _($scope.model.externalData.links).isArray()) {
                            if (_(input.data.rows).isArray() && input.data.rows.length) {
                                inputRows = sort_links(input.data.rows);
                                _($scope.model.externalData.links).each(function (link) {
                                    if (_(input.data.rows).findIndex(function (row) {
                                            return link === row.link;
                                        }) === -1) {
                                        rows.push({
                                            link: link,
                                            detections: 'clean'
                                        });
                                    }
                                });
                            } else {
                                _($scope.model.externalData.links).each(function (link) {
                                    rows.push({
                                        link: link,
                                        detections: 'clean'
                                    });
                                });
                            }
                        }
                        deferred.resolve($.extend({}, input, { data: { rows: _.union(rows, inputRows) } }));
                        $scope.model.wrapper.isLoading = false;
                        return deferred.promise;
                    }).converter(defaultListConverter, {
                        columns: $scope.model.columns,
                        converters: {
                            clickForJSONConverter: function (text, columnId, columnsMap, args) {
                                return '#' + JSON.stringify({
                                    display: 'text',
                                    text: 'Click for full results',
                                    'class': 'link-like',
                                    clickEvent: {
                                        name: 'open-link-results-viewer',
                                        results: text,
                                        link: columnsMap.link
                                    }
                                });
                            },
                            scanLinkWithVirusTotalConverter: function (text, columnId, columnsMap, args) {
                                if (!args && !args.linkColumn && !columnsMap[args.linkColumn]) {
                                    return '';
                                }
                                return '#' + JSON.stringify({
                                    display: 'external-link',
                                    text: 'Scan with VirusTotal',
                                    href: 'https://www.virustotal.com/en/url/submission/?force=1&url=' + encodeURIComponent(columnsMap[args.linkColumn]),
                                    rel: 'noreferrer'
                                });
                            },
                            detectionsConverter: function (text, columnId, columnsMap, args) {
                                var data = 'Suspicious';
                                if (!_(text).isArray() || text.length === 0) {
                                    data = 'No reports';
                                } else {
                                    if (args.final_result === 'phishing') {
                                        data = 'Phishing';
                                    }
                                }
                                return '#' + JSON.stringify({
                                    display: 'text',
                                    text: data
                                });
                            }
                        }
                    });
                }
            });
        };
        function sort_links(rows) {
            var sorted = rows;
            rows.forEach(function (row, index) {
                if (row.detections.length > 0) {
                    if (index > -1) {
                        sorted.splice(index, 1);
                        sorted.unshift(row);
                    }
                }
            });
            return sorted;
        }
    }]);
}());